import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { AuthState } from './state'
import { authGetters } from './getters'
import { authMutations } from './mutations'
import { authActions } from './actions'

Vue.use(Vuex);

export const auth = {
  namespaced: true,
  state: new AuthState(),
  getters: authGetters,
  mutations: authMutations,
  actions: authActions
} as StoreOptions<AuthState>;

export * from './types'
export * from './state'
export default auth;
